import { ConstructionTypeContainer } from '../../containers/advancedFilters/ConstructionTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const constructionType: IFilter = {
  component: ConstructionTypeContainer,
};
